export interface AmrMetadata {
  type: string;
  [key: string]: unknown;
}

export interface FieldDef {
  key: string;
  label: string;
}

export const TYPE_LABELS: Record<string, string> = {
  mbus_v1: "MBus",
  evinox_csv_v1: "Evinox CSV",
  guru_systems_csv_v1: "Guru Systems CSV",
  guru_systems_api_v1: "Guru Systems API",
  p2lpc_v1: "P2LPC",
  switch2_g6_csv_v1: "Switch2 G6 CSV",
  kamstrup_ready_csv_v1: "Kamstrup Ready CSV",
  bring_energy_bms_v1: "Bring Energy BMS",
  switch2_cmi6110_api_v1: "Switch2 CMi6110 API",
  email_receiver_v1: "Email Receiver",
  generic_csv_v1: "Generic CSV",
};

export const FIELD_CONFIG: Record<string, FieldDef[]> = {
  mbus_v1: [
    { key: "serial_number", label: "Serial Number" },
    { key: "manufacturer", label: "Manufacturer" },
    { key: "version", label: "Version" },
    { key: "asset_type", label: "Asset Type" },
    { key: "elvaco_x110_type", label: "Elvaco Type" },
  ],
  evinox_csv_v1: [
    { key: "serial_number", label: "Serial Number" },
    { key: "plot_id", label: "Plot ID" },
    { key: "asset_type", label: "Asset Type" },
  ],
  guru_systems_csv_v1: [
    { key: "serial_number", label: "Serial Number" },
    { key: "asset_type", label: "Asset Type" },
  ],
  guru_systems_api_v1: [{ key: "account_id", label: "Account ID" }],
  p2lpc_v1: [{ key: "serial_number", label: "Serial Number" }],
  switch2_g6_csv_v1: [
    { key: "serial_number", label: "Serial Number" },
    { key: "asset_type", label: "Asset Type" },
  ],
  kamstrup_ready_csv_v1: [
    { key: "serial_number", label: "Serial Number" },
    { key: "asset_type", label: "Asset Type" },
  ],
  bring_energy_bms_v1: [
    { key: "serial_number", label: "Serial Number" },
    { key: "asset_type", label: "Asset Type" },
  ],
  switch2_cmi6110_api_v1: [
    { key: "meter_serial_number", label: "Meter Serial Number" },
    { key: "network_id", label: "Network ID" },
    { key: "switch2_device_uuid", label: "Switch2 Device UUID" },
  ],
  email_receiver_v1: [{ key: "reference", label: "Reference" }],
  generic_csv_v1: [
    { key: "identifier", label: "Identifier" },
    { key: "asset_type", label: "Asset Type" },
  ],
};

export function getAmrDisplayData(amr_metadata: unknown): {
  typeLabel: string;
  fields: { label: string; value: string }[];
} | null {
  const metadata = amr_metadata as AmrMetadata | null | undefined;
  if (!metadata?.type) return null;

  const typeLabel = TYPE_LABELS[metadata.type] ?? metadata.type;
  const fieldDefs = FIELD_CONFIG[metadata.type] ?? [];

  const fields: { label: string; value: string }[] = [];
  for (const field of fieldDefs) {
    const value = metadata[field.key];
    if (value !== null && value !== undefined) {
      fields.push({ label: field.label, value: String(value) });
    }
  }

  return { typeLabel, fields };
}
